import Vue from 'vue';
import App from './App.vue';
// @ts-ignore
import VueGtm from 'vue-gtm';
import VueMeta from 'vue-meta';
import VueMq from 'vue-mq';
import './registerServiceWorker';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import { sync } from 'vuex-router-sync';

Vue.config.productionTip = false;
sync(store, router);

Vue.use(VueMeta);

Vue.use(VueMq, {
  breakpoints: {
    sm: 768,
    md: 1024,
    lg: Infinity,
  },
});

Vue.use(VueGtm, {
  id: process.env.VUE_APP_GOOGLE_ANALYTICS_TRACKING_ID,
  enabled: !!process.env.VUE_APP_GOOGLE_ANALYTICS_TRACKING_ID,
  vueRouter: router,
  debug: process.env.NODE_ENV !== 'production',
});

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app');

// const x = {
//   type: 'FeatureCollection',
//   query: ['san', 'francisco'],
//   features: [
//     {
//       id: 'place.15734669613559250',
//       type: 'Feature',
//       place_type: ['place'],
//       relevance: 1,
//       properties: { wikidata: 'Q62' },
//       text: 'San Francisco',
//       place_name: 'San Francisco, California, United States',
//       bbox: [
//         -122.517910874663,
//         37.6044780500533,
//         -122.354995082683,
//         37.8324430069081,
//       ],
//       center: [-122.463, 37.7648],
//       geometry: { type: 'Point', coordinates: [-122.463, 37.7648] },
//       context: [
//         {
//           id: 'region.9803118085738010',
//           short_code: 'US-CA',
//           wikidata: 'Q99',
//           text: 'California',
//         },
//         {
//           id: 'country.19678805456372290',
//           wikidata: 'Q30',
//           short_code: 'us',
//           text: 'United States',
//         },
//       ],
//     },
//     {
//       id: 'place.15797147722711380',
//       type: 'Feature',
//       place_type: ['place'],
//       relevance: 1,
//       properties: { wikidata: 'Q61301' },
//       text: 'San Francisco De Campeche',
//       place_name: 'San Francisco De Campeche, Campeche, Mexico',
//       bbox: [
//         -90.5865838964472,
//         19.792523418696,
//         -90.4681014093499,
//         19.8763653229026,
//       ],
//       center: [-90.52528, 19.84861],
//       geometry: { type: 'Point', coordinates: [-90.52528, 19.84861] },
//       context: [
//         {
//           id: 'region.10700090649469160',
//           short_code: 'MX-CAM',
//           wikidata: 'Q80908',
//           text: 'Campeche',
//         },
//         {
//           id: 'country.9933875229773450',
//           wikidata: 'Q96',
//           short_code: 'mx',
//           text: 'Mexico',
//         },
//       ],
//     },
//     {
//       id: 'place.6734635062361910',
//       type: 'Feature',
//       place_type: ['place'],
//       relevance: 1,
//       properties: { wikidata: 'Q16628330' },
//       text: 'San Francisco',
//       place_name: 'San Francisco, Zulia, Venezuela',
//       bbox: [-71.758432, 10.519168, -71.608914, 10.615895],
//       center: [-71.67651, 10.54875],
//       geometry: { type: 'Point', coordinates: [-71.67651, 10.54875] },
//       context: [
//         {
//           id: 'region.16267835172619380',
//           short_code: 'VE-V',
//           wikidata: 'Q43269',
//           text: 'Zulia',
//         },
//         {
//           id: 'country.8950424814360550',
//           wikidata: 'Q717',
//           short_code: 've',
//           text: 'Venezuela',
//         },
//       ],
//     },
//     {
//       id: 'poi.979252571288',
//       type: 'Feature',
//       place_type: ['poi'],
//       relevance: 1,
//       properties: {
//         address: 'N McDonnell Rd',
//         wikidata: 'Q8688',
//         landmark: true,
//         category: 'airport',
//         maki: 'airport',
//       },
//       text: 'San Francisco International Airport (SFO)',
//       place_name:
//         'San Francisco International Airport (SFO), N McDonnell Rd, San Francisco, California 94128, United States',
//       center: [-122.381047, 37.617801],
//       geometry: { coordinates: [-122.381047, 37.617801], type: 'Point' },
//       context: [
//         { id: 'neighborhood.285261', text: 'Bayside Manor' },
//         { id: 'postcode.8070390524138280', text: '94128' },
//         {
//           id: 'place.15734669613559250',
//           wikidata: 'Q62',
//           text: 'San Francisco',
//         },
//         {
//           id: 'region.9803118085738010',
//           short_code: 'US-CA',
//           wikidata: 'Q99',
//           text: 'California',
//         },
//         {
//           id: 'country.19678805456372290',
//           wikidata: 'Q30',
//           short_code: 'us',
//           text: 'United States',
//         },
//       ],
//     },
//     {
//       id: 'place.5464395516267000',
//       type: 'Feature',
//       place_type: ['place'],
//       relevance: 1,
//       properties: { wikidata: 'Q1781109' },
//       text: 'San Francisco Coacalco',
//       place_name: 'San Francisco Coacalco, México, Mexico',
//       bbox: [
//         -99.1285116806486,
//         19.6103088790828,
//         -99.0724699048157,
//         19.6640439404688,
//       ],
//       center: [-99.10417, 19.62889],
//       geometry: { type: 'Point', coordinates: [-99.10417, 19.62889] },
//       context: [
//         {
//           id: 'region.12430401993456720',
//           short_code: 'MX-MEX',
//           wikidata: 'Q82112',
//           text: 'México',
//         },
//         {
//           id: 'country.9933875229773450',
//           wikidata: 'Q96',
//           short_code: 'mx',
//           text: 'Mexico',
//         },
//       ],
//     },
//   ],
//   attribution:
//     'NOTICE: © 2020 Mapbox and its suppliers. All rights reserved. Use of this data is subject to the Mapbox Terms of Service (https://www.mapbox.com/about/maps/). This response and the information it contains may not be retained. POI(s) provided by Foursquare.',
// };
